var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('keep-alive',{attrs:{"include":_vm.cacheList,"exclude":_vm.notCacheName}},[_c('div',[_vm._v("This is parent View")]),_c('router-view',{ref:"child"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }